import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SectionTitle",
  props: {
    titleType: {
      type: String,
      default: "title",
      validator: value => {
        var _context;
        return _includesInstanceProperty(_context = ["title", "subtitle"]).call(_context, value);
      }
    }
  },
  setup() {}
});